import React, { useEffect, useState } from "react";
import PaginationDiv from "modules/pagination/PaginationDiv";
import CardDiv from "modules/common/card-div/CardDiv";
import { Placeholder } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getFormattedDate } from "modules/utilities/utility";
import SoftBadge from "modules/common/SoftBadge";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import AscendingLogoGrey from "assets/img/illustrations/AscendingLogoGrey";
import DescendingLogoGrey from "assets/img/illustrations/DescendingLogoGrey";
import moment from "moment";

function DoctorsTable({ doctorsData, doctorsLoading }) {
  const [tableData, setTableData] = useState(doctorsData);
  const [page, newPage] = useState(1);
  const [filterData, setFilter] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [opa, setOpa] = useState("");
  const [count, setCount] = useState(1);

  useEffect(() => {
    setTableData(doctorsData);
  }, [doctorsData]);

  useEffect(() => {
    const numOfSubarrays = Math.max(
      Math.ceil((tableData?.length || 0) / 10),
      0
    );
    const arrayOfArrays = tableData
      ? Array.from({ length: numOfSubarrays }, (_, i) => {
          const start = i * 10;
          const end = start + 10;
          return tableData?.slice(start, end);
        })
      : [];
    setPageCount(Math.max(Math.ceil((tableData?.length || 0) / 10), 1));
    setFilter(arrayOfArrays[page - 1]);
  }, [tableData, page]);

  const handleSortSlotTime = () => {
    if (count === 0) {
      setOpa("dsc");
      setCount(1);
      setFilter([
        ...tableData.sort(
          (a, b) => moment(a?.slot?.slot_time) - moment(b?.slot?.slot_time)
        ),
      ]);
    } else if (count === 1) {
      setOpa("asc");
      setCount(2);
      setFilter([
        ...tableData.sort(
          (a, b) => moment(b?.slot?.slot_time) - moment(a?.slot?.slot_time)
        ),
      ]);
    } else if (count === 2) {
      setOpa("");
      setCount(0);
      setFilter([...tableData]);
    }
  };

  return (
    <div>
      <CardDiv
        component={
          <div
            style={{ maxHeight: "75vh", overflowY: "scroll" }}
            className="scrollable-container shadow rounded-bottom"
          >
            <div
              style={{ background: "#F9FAFD" }}
              className="d-flex rounded-top p-1 text-black  fw-bold"
            >
              <div className="ps-4" style={{ flex: 1 }}>
                Name
              </div>
              <div style={{ flex: 1 }}>Email</div>
              <div className="flex-1">Booking Time</div>
              <div
                className="flex-1  fixed-width cursor-pointer"
                onClick={handleSortSlotTime}
              >
                <OverlayTrigger
                  overlay={
                    <Tooltip
                      style={{ position: "fixed" }}
                      id="overlay-trigger-example"
                    >
                      {count == 0 ? (
                        <span className="fw-bold">Click to sort ascending</span>
                      ) : count == 1 ? (
                        <span className="fw-bold">
                          Click to sort Descending
                        </span>
                      ) : (
                        <span className="fw-bold">Click to cancel sort</span>
                      )}
                    </Tooltip>
                  }
                >
                  <span
                    style={{ display: "inline-block", verticalAlign: "middle" }}
                  >
                    Slot Time
                  </span>
                </OverlayTrigger>
                <div
                  style={{
                    display: "inline-block",
                    verticalAlign: "middle",
                    paddingLeft: "1rem",
                  }}
                >
                  <div
                    className={
                      opa === ""
                        ? "opacity-100"
                        : opa === "asc"
                        ? "opacity-50"
                        : "opacity-100"
                    }
                  >
                    <AscendingLogoGrey />
                  </div>
                  <div
                    className={
                      opa === ""
                        ? "opacity-100"
                        : opa === "dsc"
                        ? "opacity-50"
                        : "opacity-100"
                    }
                  >
                    <DescendingLogoGrey />
                  </div>
                </div>
              </div>
            </div>
            <div className="gap-5">
              {doctorsLoading ? (
                <div className="px-3">
                  <Placeholder as="p" animation="wave">
                    <div className="d-flex justify-content-between gap-3 py-3">
                      <Placeholder xs={2} bg="primary" />
                      <Placeholder xs={3} bg="secondary" />
                      <Placeholder xs={3} bg="secondary" />
                      <Placeholder xs={3} bg="secondary" />
                    </div>
                    <Placeholder xs={4} bg="secondary" />
                  </Placeholder>
                </div>
              ) : doctorsData.length ? (
                filterData?.map((member, index) => {
                  return (
                    <div
                      className={`d-flex border border-top-0 ps-4 py-3  ${
                        index === doctorsData?.length - 1 && `rounded-bottom`
                      }`}
                    >
                      <div style={{ flex: 1 }} className="d-flex flex-column">
                        <Link
                          to={`/lead-details/${member?.case?.id}`}
                          className="fw-bold"
                        >
                          {member?.case?.user.first_name}
                        </Link>
                        <span className="text-black mt-2">
                          {member?.case?.user?.phone_number}
                        </span>
                      </div>
                      <div style={{ flex: 1 }} className=" text-black">
                        {member?.case?.user?.email}
                        <br></br>
                        {/* payment_status.replaceAll("_", " ").toUpperCase() */}
                        {member?.payment_status
                          .replaceAll("_", " ")
                          .toUpperCase() == "PAID" ? (
                          <SoftBadge bg="primary" className="me-2 fw-bold">
                            {member?.payment_status}
                          </SoftBadge>
                        ) : (
                          <SoftBadge
                            bg="secondary"
                            className="me-2 text-black fw-bold"
                          >
                            {member?.payment_status}
                          </SoftBadge>
                        )}
                      </div>
                      <div className="flex-1 text-black">
                        {getFormattedDate(member?.created_at)}
                      </div>
                      <div style={{ flex: 1 }}>
                        {getFormattedDate(member?.slot?.slot_time)}
                      </div>
                    </div>
                  );
                })
              ) : (
                <div>No Data</div>
              )}
            </div>
            <PaginationDiv
              paginationData={{ pageCount: pageCount || 1, page: page }}
              newPage={newPage}
            />
          </div>
        }
        title={"My Appointment"}
      />
    </div>
  );
}

export default DoctorsTable;
